import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2, ButtonLink } from '@blueprint/ui';
import { TickNormalMedium } from '@blueprint/icons';

export const Wrapper = styled.div(
    ({ theme: { mq } }) =>
        css`
            width: 100%;
            display: flex;
            flex-direction: column;

            ${mq.medium} {
                margin-left: 12px;
                max-width: 721px;
            }
        `
);

export const Image = styled.img(
    ({ theme: { mq } }) =>
        css`
            display: flex;
            max-width: 100%;
            width: 100%;
            height: auto;

            ${mq.medium} {
                width: 100%;
            }
        `
);

export const MainContent = styled.div(
    ({ theme: { spacing } }) =>
        css`
            width: 100%;
            display: flex;
            flex-direction: column;
            padding-top: ${spacing['16px']};
        `
);

export const Heading = styled(Heading2)(
    ({ theme: { spacing } }) =>
        css`
            margin-bottom: ${spacing['8px']};
        `
);

export const Preamble = styled('p')(
    ({ theme }) =>
        css`
            margin: 0 0 12px 0;
            line-height: ${theme.type.lineHeight};
            font-size: ${theme.type.body};
            color: ${theme.colors['text-body']};
        `
);

export const Ticks = styled(TickNormalMedium)(
    ({ theme: { colors, spacing } }) =>
        css`
            min-width: ${spacing['24px']};
            color: ${colors['primary-brand']};
        `
);

export const ReasonToJoin = styled('p')(
    ({ theme: { spacing, type, colors } }) => {
        return css`
            margin: 0 0 ${spacing['8px']} ${spacing['16px']};
            line-height: ${type.lineHeight};
            font-size: ${type.body};
            color: ${colors['text-body']};
        `;
    }
);

export const StyledTickWrapper = styled('div')`
    display: flex;
`;

export const ButtonsWrapper = styled.div(({ theme: { spacing } }) => {
    return css`
        display: flex;
        width: 100%;
        margin-top: ${spacing['16px']};
    `;
});

export const RegButton = styled(ButtonLink)(
    ({ theme: { spacing, mq, borderRadius } }) => {
        return css`
            flex-grow: 1;
            height: ${spacing['48px']};
            display: flex;
            border-radius: ${borderRadius['300']};

            ${mq.medium} {
                max-width: 90px;
            }
        `;
    }
);
export const LoginButton = styled(ButtonLink)(
    ({ theme: { spacing, mq, borderRadius } }) => {
        return css`
            max-width: 75%;
            height: ${spacing['48px']};
            display: flex;
            border-radius: ${borderRadius['300']};

            ${mq.medium} {
                max-width: 90px;
            }
        `;
    }
);
